import React from "react";
import ScrollReveal from "../layouts/ScrollReveal";

const Footer = () => {
  return (
    <footer className="w-full py-10 bg-[#05080F] border-t-[1px] border-t-[rgba(30,41,59,0.3)]">
      <ScrollReveal>
        <div className="flex flex-col items-center justify-center max-w-screen-xl mx-auto px-6">
          <p className="font-sans font-normal text-sm text-grayText text-center py-4">
            © {new Date().getFullYear()} Imtiaz Pranto. All Rights Reserved.
          </p>
        </div>
      </ScrollReveal>
    </footer>
  );
};

export default Footer;
